<template>
    <div class="well-rank" :class="{ 'top-rank': rank < 4 }" :title="$translate('ai_rank')">
        <img class="crown" src="/static/svg/rankcrown.svg" alt="" />

        <span class="title">{{ $translate('rank') }}</span>

        <div class="value">
            <span v-if="hasRank">#{{ rank }}</span>

            <span v-else-if="showNA" class="na">{{ $translate('na') }}</span>

            <span v-else-if="hazards" class="score-hazard">
                <img
                    v-if="degHazard"
                    src="/static/svg/Hazard_Deg_white.svg"
                    alt=""
                    :title="$translate('degenerated_oocyte')"
                />

                <img
                    v-else-if="pnHazard"
                    src="/static/svg/Hazard_PN_white.svg"
                    alt=""
                    :title="$uiUtils.formatPnHazardMessage(pnCount)"
                />

                <img
                    v-else-if="showDucInsteadRank"
                    src="/static/svg/Hazard_Duc_white.svg"
                    alt=""
                    :title="$translate('duc_tooltip')"
                />
            </span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'WellRank',
    props: {
        well: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getPnCount: 'timelapse/getPnCount',
            getPnHazard: 'timelapse/getPnHazard',
            checkDucsHazard: 'timelapse/checkDucsHazard',
            checkDegeneratedOocyteHazard: 'timelapse/checkDegeneratedOocyteHazard'
        }),
        rank() {
            return this.well.kidRank
        },
        pnCount() {
            return this.getPnCount(this.well)
        },
        pnHazard() {
            return this.getPnHazard(this.well)
        },
        degHazard() {
            return this.checkDegeneratedOocyteHazard(this.well)
        },
        showDucInsteadRank() {
            if (this.checkDucsHazard(this.well) && this.well.excludeFromRanking === undefined) {
                return true
            }
            return this.checkDucsHazard(this.well) && this.well.excludeFromRanking
        },
        hazards() {
            return this.pnHazard || this.degHazard || this.showDucInsteadRank
        },
        hasRank() {
            return this.rank && !this.hazards
        },
        showNA() {
            return !this.rank && !this.hazards
        }
    }
}
</script>

<style lang="scss" scoped>
.well-rank {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    border-radius: $border-radius;
    background-color: $dark-4;

    &.top-rank {
        .crown {
            position: absolute;
            overflow: hidden;
            width: 2rem;
            top: 0;
            left: 0;
        }
    }
    &:not(.top-rank) {
        .crown {
            display: none;
        }
    }

    .title {
        font-size: 10pt;
        color: $light;
    }

    .value {
        position: relative;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        color: $light-3;
        font-size: 18pt;
        font-weight: 600;

        .ai-icon {
            margin-right: 0.5rem;
        }

        .score-hazard img {
            height: 1.4rem;
        }
    }
}
</style>
